<script setup lang="ts">
import { useLiff } from '@/composables/liff/useLiff'

const { isInitialized } = useLiff()

const initPage = async () => {
}

await initPage()

onMounted(() => {
  console.log('index: onMounted')
})

</script>

<template>
  <div class="page-home" />
</template>

<style lang="scss" scoped>
.page-home {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100svh;
  background-color: #f2f2f2;
}
</style>
